import { Address } from "./address";
import { AddressRepository } from "./addressRepository";

/**
 * Implementação de {@link AddressRepository} utilizando a API pública ViaCEP.
 */
export class AddressRepositoryImpl implements AddressRepository {
  /**
   * Consulta a API ViaCEP e retorna o endereço associado ao CEP informado.
   * @param cep CEP contendo 8 dígitos numéricos
   * @returns Endereço encontrado
   * @throws {Error} Quando a requisição falha ou o CEP não é encontrado
   */
  async findByCep(cep: string): Promise<Address> {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
      method: "GET",
      mode: "cors",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error("Falha na consulta à API");
    }
    const data = await response.json();
    if (data.erro === "true" || data.erro === true) {
      throw new Error("CEP não encontrado");
    }
    return Address.from(data);
  }
}
